/*@flow*/

export default function isArray(x: any): %checks {
  return Array.isArray(x);
}
